import React, { useRef } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useResetPassword } from "../adapters/uplist";
import { useAlertActions } from "../context/AlertContext";
import AuthPage from "./hoc/AuthPage";
import { Input } from "../components/fields";

const RecoverSent = ({ reset }) => {
  return (
    <div className="text-center">
      <h3>Password Recovery Email Sent</h3>
      <Link onClick={reset} to="/login">
        Log In
      </Link>
    </div>
  );
};

export const ForgotPasswordModal = ({ handleClose, onSent }) => {
  const onClose = () => {
    handleClose();
    onSent && onSent();
  };
  return (
    <Modal.Body>
      <ForgotPasswordForm handleClose={onClose} modal />
    </Modal.Body>
  );
};

export const ForgotPasswordForm = ({ handleClose, modal }) => {
  const ref = useRef();
  const { setAlert } = useAlertActions();
  const methods = useForm();
  const { mutate, isSuccess, isLoading, reset } = useResetPassword({
    onSuccess: () => {
      setAlert("Email successfully sent.", "success");
      if (handleClose) handleClose();
    },
    onError: ({ response: { data } }) => {
      methods.setError(
        "email",
        { type: "validate", message: data || "Something went wrong" },
        { shouldFocus: true }
      );
    },
  });
  return (
    <FormProvider formRef={ref} {...methods}>
      <Form ref={ref} onSubmit={methods.handleSubmit(mutate)} noValidate>
        {isSuccess ? (
          <RecoverSent reset={reset} />
        ) : (
          <>
            <p className="text-muted">
              {!modal ? (
                <span>
                  Please enter your email address. You will receive a link to
                  create a new password via email.
                </span>
              ) : (
                <span>
                  Enter the email we usually use to contact you. You will
                  receive a link to create a new password via email.
                </span>
              )}
            </p>
            <Input
              name="email"
              type="email"
              label="Email"
              autoComplete="username"
              required
            />
            <Button
              className="mb-3"
              type="submit"
              size="lg"
              block
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send"}
            </Button>
          </>
        )}
      </Form>
    </FormProvider>
  );
};

const ForgotPasswordPage = () => {
  return (
    <AuthPage>
      <ForgotPasswordForm />
    </AuthPage>
  );
};

export default ForgotPasswordPage;
